import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import AccessGuard from 'components/shared/AccessGuard';
import Button from 'components/shared/Button';
import { Accessor } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import { BodySmall, H3 } from 'styles/typography';
import ReferralSourceIcon from 'svg/ReferralSourceIcon';

export type ReferralSourceEmptyStateProps = {
  onAdd: () => void;
  createPermission: Accessor;
};

// Shown when the client has no referral sources at all, which is an ordinary starting state rather
// than an error: the category is created on the first save.
export default function ReferralSourceEmptyState({ onAdd, createPermission }: ReferralSourceEmptyStateProps) {
  return (
    <Container data-testid='referral-sources-empty'>
      <ReferralSourceIcon width={24} height={24} style={{ color: colors.blue100 }} />
      <H3>No Referral Sources</H3>
      <BodySmall color={colors.black100}>
        Keep track of your referral sources and match names to ensure referrals are linked properly.
      </BodySmall>
      <AccessGuard accessor={createPermission}>
        <AddButton variant='primary' onClick={onAdd}>
          Add New Referral Source
        </AddButton>
      </AccessGuard>
    </Container>
  );
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
`;

const AddButton = styled(Button)`
  margin-top: 16px;
`;
